import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { DownloadRequestService } from '@core/services/download-request.service';
import { ConfirmationModalComponent } from '@shared/components/confirmation-modal/confirmation-modal.component';
import { take } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'drdp-download-demographics-ratings',
    templateUrl: './download-demographics-ratings.component.html',
    styleUrls: ['./download-demographics-ratings.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DownloadDemographicsRatingsComponent implements OnInit {
  is2025Page: boolean = false;
  title: string = '';
  downloadService = inject(DownloadRequestService);
  dialog = inject(MatDialog);
  private route = inject(ActivatedRoute);
  constructor(private translocoService: TranslocoService) {}

  ngOnInit(): void {
    this.is2025Page = this.route.snapshot.data['isEarlyAdopter'] ?? false;
    this.title = this.translocoService.translate('downloads.ratings.title', {
      year: this.is2025Page ? '2025' : '2015',
    });
  }
  downloadDemographics(searchValues: any) {
    searchValues = { ...searchValues, isEarlyAdopter: this.is2025Page };

    this.downloadService
      .saveRequestForRatings(searchValues)
      .pipe(take(1))
      .subscribe((res) => {
        if (res) {
          this.displaySuccessMessage();
        }
      });
  }

  displaySuccessMessage() {
    const modal = {
      data: {
        modalInfo: {
          title: this.translocoService.translate('downloads.requestSubmitted.title'),
          message: this.translocoService.translate(
            'downloads.requestSubmitted.message'
          ),
          primaryBtnClass: 'blue',
          primaryBtnText: this.translocoService.translate('downloads.requestSubmitted.okButton'),
          showCancel: false,
        },
      },
    };

    this.dialog.open(ConfirmationModalComponent, {
      data: modal,
    });
  }
}
